import { cn } from "@/shared/lib/cn";

/**
 * ELTE brand mark for the external-login button.
 *
 * SKIN: swaps with the asset at `public/logo-elte.svg` (same path) — no code change,
 * mirroring the `Logo`/favicon pattern. Sized to fill the Button's icon slot.
 */
export function ElteIcon({ className }: { className?: string }) {
  return (
    <img
      alt=""
      aria-hidden="true"
      className={cn("h-full w-full object-contain", className)}
      draggable={false}
      src="/logo-elte.svg"
    />
  );
}
